<app-view-item *ngIf="disabled" [text]="selected?.code" [tabindex]="tabindex"></app-view-item>
<div class="stock-class-select-container" *ngIf="!disabled">
  <nz-select #selector nzShowSearch nzServerSearch [nzAllowClear]="nzAllowClear" [nzBackdrop]="addBackdrop"
    [nzFilterOption]="nzFilterOption" (nzOnSearch)="onSearch($event)" (nzOpenChange)="onDropdownOpenChange($event)"
    [nzCustomTemplate]="displayTpl" (nzScrollToBottom)="loadMore()" (keydown)="handleKeyDown($event)"
    (click)="handleClick($event)" [(ngModel)]="value" (ngModelChange)="valueChanged($event)"
    [nzDropdownMatchSelectWidth]="false" nzDropdownClassName="dropdownSelect" class="width-100" [nzOptionHeightPx]="32"
    [nzOptionOverflowSize]="6" [nzPlacement]="'bottomLeft'" [tabindex]="tabindex" [nzMode]="mode">

    <ng-template #displayTpl let-selected>
      {{ selected.nzLabel }}
    </ng-template>

    <!-- Custom Add New Button at top -->
    <ng-container *aclIf="{ ability: ['m1.8', 'stkcls.create'], mode: 'allOf' }">
      <nz-option *ngIf="!searching && showAddNewButton && !this.NotShowInReport" [nzValue]="''" nzCustomContent>
        <div class="text-center">
          <button type="button" nz-button nzType="primary" class="add-new-button" (click)="$event.stopPropagation(); onAddNewClick($event)">
            <span nz-icon nzType="plus"></span>
            {{ storedInstantData ? " Add New '" + storedInstantData + "'" : ' Add New' }}
          </button>
        </div>
      </nz-option>
    </ng-container>

    <ng-container *ngFor="let o of list">
      <nz-option *ngIf="!searching" [nzValue]="getValue(o)" [nzLabel]="o.code" nzCustomContent>
        <span>{{ o.code }}</span>
      </nz-option>
    </ng-container>
  </nz-select>

  <!-- Inline Add Panel -->
  <app-inline-add-panel #inlineAddPanel [config]="stockClassConfig" [visible]="showInlineAddPanel"
    [initialData]="inlineDefaults" (itemCreated)="onStockClassCreated($event)" (cancelled)="onStockClassCancelled()"
    (visibleChange)="showInlineAddPanel = $event" (moreDetails)="onStockClassMoreDetails()"
    (fieldChange)="onFieldChange($event)">
  </app-inline-add-panel>
</div>